import { Alert, Box, Button, Container, Divider, Fab, Tab, Tabs, Tooltip, Typography } from '@mui/material'
import React, { useEffect, useState } from 'react'
import "../../styles/events.css"; // Import CSS
import { theme } from '../../styles/theme';
import ManageEventsCardComponent from './components/ManageEventsCardComponent';
import Grid from '@mui/material/Grid2';
import { AddCircleRounded } from '@mui/icons-material';
import LocalActivityIcon from '@mui/icons-material/LocalActivity';
import { cardGridSize } from '../../utils/constants';
import { AppBarPadding, BottomPadding } from '../../utils/helperUtils';
import { useNavigate, useParams } from 'react-router-dom';
import SearchComponent from './components/SearchComponent';
import { useAuth } from '../../context/AuthContext';
import { DeleteEventListingAuth, fetchUserAppliedEventsAuth, fetchUserEventListingsAuth, UpdateEventListingAuth, WithdrawEventApplicationAuth } from '../../services/eventServices';
import LoadingComponent from '../components/LoadingComponent';
import { useSnackbar } from '../../context/SnackbarContext';
import ConfirmDialogComponent from '../components/ConfirmDialogComponent';

function ManageEventsView() {

  const { tabLocation = "1" } = useParams();

  const [showDraftAlert, setShowDraftAlert] = useState(false);

  useEffect(() => {
    const dismissed = localStorage.getItem("dismissedDraftAlert");
    setShowDraftAlert(dismissed !== "true");
  }, []);

  const handleCloseDraftAlert = () => {
    setShowDraftAlert(false);
    localStorage.setItem("dismissedDraftAlert", "true");
  };

  const navigate = useNavigate();
  const showSnackbar = useSnackbar();

  const { login, logout } = useAuth();

  const [searchQuery, setSearchQuery] = useState("");
  const [organizedEvents, setOrganizedEvents] = useState([]);
  const [appliedEvents, setAppliedEvents] = useState([]);
  const [organizedEventsError, setOrganizedEventsError] = useState("");
  const [appliedEventsError, setAppliedEventsError] = useState("");
  const [loading, setLoading] = useState(true);
  const [tabValue, setTabValue] = React.useState(tabLocation);
  const [refreshKey, setRefreshKey] = useState(0);
  const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);
  const [selectedEventSlug, setselectedEventSlug] = useState(null);
  const [selectedVendorSlug, setSelectedVendorSlug] = useState(null);
  const [loadingFullScreen, setLoadingFullScreen] = useState(false);

  const [error, setError] = useState("");


  useEffect(() => {
    const fetchOrganizedEvents = async () => {
      try {
        const response = await fetchUserEventListingsAuth(login, logout);
        if (response.success) {
          setOrganizedEvents(response.data);
        } else {
          console.error("Failed to fetch organized events:", response.error);
        }
      } catch (err) {
        console.error("Unexpected error fetching organized events:", err);
        setOrganizedEventsError(err.message);
      } finally {
        setLoading(false); // Optional: Only set false if loading was true here
      }
    };

    setLoading(true);
    fetchOrganizedEvents();
  }, [refreshKey]);

  useEffect(() => {
    const fetchAppliedEvents = async () => {
      try {
        const response = await fetchUserAppliedEventsAuth(login, logout);
        if (response.success) {
          setAppliedEvents(response.data);
        } else {
          console.error("Failed to fetch applied events:", response.error);
        }
      } catch (err) {
        console.error("Unexpected error fetching applied events:", err);
        setAppliedEventsError(err.message);
      } finally {
        setLoading(false); // Optional: Track separate loading states if needed
      }
    };

    setLoading(true);
    fetchAppliedEvents();
  }, [refreshKey]);

  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
  };

  const handleSubmitApplication = async (slug) => {
    setLoading(true);
    try {
      const response = await UpdateEventListingAuth(slug, { status: "review" }, login, logout, "Submit Event Error");
      if (response.success) {
        showSnackbar("🎉 Event Application was submitted!", "success");
        console.log("Application submitted for review");
        // Optionally trigger UI update
        setRefreshKey(prev => prev + 1);
      } else {
        console.error("Failed to submit application:", response.error);
      }
    } catch (error) {
      setOrganizedEventsError(error.message)
      console.error("Error submitting application:", error);
    }
    finally {
      setTimeout(() => {
        setLoading(false);
      }, 3000);
    }
  }

  const handleDelete = async () => {
    setLoadingFullScreen(true)
    setLoading(true);
    try {
      const response = await DeleteEventListingAuth(selectedEventSlug, login, logout);
      if (response.success) {
        showSnackbar("💣 Event Application was deleted!", "success");
        setRefreshKey(prev => prev + 1);
        // Optionally trigger UI update
      } else {
        console.error("Failed to submit application:", response.error);
      }
    } catch (error) {
      setOrganizedEventsError(error.message)
      console.error("Error submitting application:", error);
    }
    finally {
      setDeleteDialogOpen(false)
      setTimeout(() => {
        setLoading(false);
        setLoadingFullScreen(false)
      }, 3000);
    }
  }

  const handleWithdraw = async () => {
    try {
      setLoadingFullScreen(true);
      setLoading(true);
      const response = await WithdrawEventApplicationAuth(selectedEventSlug, selectedVendorSlug, login, logout);
      console.log({selectedEventSlug})
      console.log({selectedVendorSlug})
      if (response.success) {
        showSnackbar("Application withdrawn successfully!", "success");
        setRefreshKey(prev => prev + 1);
      } else {
        setError("Failed to withdraw application.");
      }
    } catch (err) {
      console.error("Error withdrawing application:", err);
      setError(err.message);
    } finally {
      setDeleteDialogOpen(false)
      setTimeout(() => {
        setLoading(false);
        setLoadingFullScreen(false)
      }, 3000);
    }
  };

  const promptDelete = (eventSlug, vendorSlug="") => {
    setselectedEventSlug(eventSlug);
    setSelectedVendorSlug(vendorSlug);
    setDeleteDialogOpen(true);
  };
  

  const filteredOrganizedEvents = organizedEvents.filter(event =>
    event.name?.toLowerCase().includes(searchQuery.toLowerCase())
  );

  const filteredAppliedEvents = appliedEvents.filter(event =>
    event.event_name?.toLowerCase().includes(searchQuery.toLowerCase())
  );


  const FloatingActionButton = () => {
    const handleClick = (e) => {
      e?.preventDefault();
      if (tabValue === '1') {
        navigate("/_/events/organizer/create");
      } else {
        navigate("/_/events/explore");
      }
    };

    return (
      <Tooltip title={tabValue === '1' ? "Create New Event" : "Find New Events"} arrow>
        <Fab
          variant="extended"
          onClick={(e) => handleClick(e)}
          sx={{
            position: "fixed",
            bottom: 20,
            right: 20,
            backgroundColor: theme.colors.events.secondary,
            color: theme.colors.events.primaryDark,
            fontWeight: "bold",
            "&:hover": {
              backgroundColor: theme.colors.events.primary,
            },
          }}
        >
          {tabValue === '1' ? (
            <>
              <AddCircleRounded sx={{ mr: 1 }} />
              Create New Event
            </>
          ) : (
            <>
              <LocalActivityIcon sx={{ mr: 1 }} />
              Find New Events
            </>
          )}
        </Fab>
      </Tooltip>
    );
  };

  const onSearchClick = (searchQuery) => {
    setSearchQuery(searchQuery)
  }

  return (
    <Box bgcolor={theme.colors.events.primary}>
      <Container maxWidth="xl" className="events-box-container">
        <AppBarPadding />
        <Grid container justifyContent={'center'}>
          <Grid size={{ md: 12, lg: 6 }}>
            <Typography fontSize={30} color={theme.colors.events.secondary}>
              <Box sx={{ fontWeight: 'bold', mb: 1 }}>
                Your Events 🗓️
              </Box>
            </Typography>
            <Divider sx={{ borderBottomWidth: 2, bgcolor: theme.colors.events.secondary }} />
            {
              error && (
                <Box textAlign="center" mt={4} className="box-container">
                  <Typography color="error" variant="h6">⚠️ {error || 'Something went wrong, please try again later'}</Typography>
                </Box>
              )
            }
            <SearchComponent
              searchQuery={searchQuery}
              setSearchQuery={setSearchQuery}
            // onSearchClick={onSearchClick}
            />
            <Tabs
              value={tabValue}
              onChange={handleTabChange}
              TabIndicatorProps={{ style: { backgroundColor: theme.colors.events.secondary } }}
              sx={{
                color: `${theme.colors.events.secondary} !important`,
                '& .MuiTab-root': {
                  color: `${theme.colors.events.secondary} !important`, // 👈 Color for selected tab
                },
              }}
            >
              <Tab label="Organizing" value="1" />
              <Tab label="Participating" value="2" />
            </Tabs>
            {loading ? (
              <LoadingComponent fullScreen={loadingFullScreen} />
            ) : (
              tabValue === '1'
                ? (filteredOrganizedEvents.length === 0 ? (
                  <Typography
                    variant="h6"
                    textAlign="center"
                    color={theme.colors.events.secondary}
                    mt={3}
                    p={4}
                  >
                    {organizedEventsError ? `⚠️ ${organizedEventsError}` : "🚫 No events yet! Tap “Create New Event” ⬇️ and get started 🎉"}
                  </Typography>
                ) : (
                  <Grid container spacing={2} mt={2}>
                    <Grid size={{ xs: 12 }}>
                      {showDraftAlert && (
                        <Alert severity="info" onClose={handleCloseDraftAlert}
                          sx={{ borderRadius: 4 }}
                        >
                          New/Updated events are saved as drafts until submitted
                        </Alert>
                      )}
                    </Grid>
                    {filteredOrganizedEvents.map((event, index) => (
                      <Grid size={cardGridSize} key={index}>
                        <ManageEventsCardComponent eventInfo={event}
                          handleSubmitApplication={handleSubmitApplication}
                          handleDelete={promptDelete} />
                      </Grid>
                    ))}
                  </Grid>
                ))
                : (filteredAppliedEvents.length === 0 ? (
                  <>
                  <Typography
                    variant="h6"
                    textAlign="center"
                    color={theme.colors.events.secondary}
                    mt={3}
                    p={4}
                  >
                    {appliedEventsError ? `⚠️ ${appliedEventsError}` : "🙋‍♂️ No applications yet! Explore events and apply to participate 🎯"}
                      </Typography>
                      {appliedEventsError && (
                        <Box justifyContent={'center'} display={'flex'}>
                          <Button
                            // fullWidth
                            // size={'small'}
                            onClick={() => { navigate('/_/storefront/create')}}
                            variant="contained"
                            sx={{
                              // textAlign: 'left',
                              // p: 2,
                              borderRadius: 5,
                              bgcolor: theme.colors.secondary,
                              // color: 'white',
                              // justifyContent: 'flex-start',
                              gap: 1,
                            }}
                          >
                            <Typography>🤩</Typography>
                            <Typography >Create Storefront</Typography>
                          </Button>
                        </Box>
                      )}
                    </>
                ) : (
                  <Grid container spacing={2} mt={2}>
                    {filteredAppliedEvents.map((event, index) => (
                      <Grid size={cardGridSize} key={index}>
                        <ManageEventsCardComponent 
                        eventInfo={event} 
                        eventApplication={true}
                        handleWithdraw={promptDelete} />
                      </Grid>
                    ))}
                  </Grid>
                ))
            )}
          </Grid>
        </Grid>
        {deleteDialogOpen && (
          <ConfirmDialogComponent
            dialogOpen={deleteDialogOpen}
            dialogTitle={`Are you sure you want to ${tabValue == 1 ? 'delete this event' : 'withdraw your application'}?`}
            dialogContent="This action cannot be undone. The event will be permanently deleted."
            primaryBtnText="Delete"
            secondaryBtnText="Cancel"
            primaryBtnBgColor={theme.colors.red}
            onSubmit={tabValue == 1 ? handleDelete : handleWithdraw}
            onClose={() => setDeleteDialogOpen(false)}
          />
        )}
        <FloatingActionButton />
        <BottomPadding />
      </Container>
    </Box>
  )
}

export default ManageEventsView